export const adminEvent = (params: { eventId: number }) => `event:${params.eventId}`;
